import { css } from 'styled-components';
import { mediaQuery, cssVar } from 'src/app/styles/helper';
import { SpacingAndSizePropKeys } from 'src/app/styles/spacing';

export interface MaxWidthProps {
  maxWidth?: SpacingAndSizePropKeys;
  maxWidthSm?: SpacingAndSizePropKeys;
  maxWidthMd?: SpacingAndSizePropKeys;
  maxWidthLg?: SpacingAndSizePropKeys;
  maxWidthXl?: SpacingAndSizePropKeys;
  maxWidth2xl?: SpacingAndSizePropKeys;
}

export type StyledMaxWidthProps = {
  [K in keyof MaxWidthProps as `$${K}`]: MaxWidthProps[K];
};

export const maxWidthStyles = css<StyledMaxWidthProps>`
  ${({ $maxWidth }) => $maxWidth && `max-width: ${cssVar($maxWidth)};`}

  ${({ $maxWidth2xl }) =>
    $maxWidth2xl &&
    mediaQuery(
      '2xl',
      css`
        max-width: ${cssVar($maxWidth2xl)};
      `
    )}

  ${({ $maxWidthXl }) =>
    $maxWidthXl &&
    mediaQuery(
      'xl',
      css`
        max-width: ${cssVar($maxWidthXl)};
      `
    )}

  ${({ $maxWidthLg }) =>
    $maxWidthLg &&
    mediaQuery(
      'lg',
      css`
        max-width: ${cssVar($maxWidthLg)};
      `
    )}

  ${({ $maxWidthMd }) =>
    $maxWidthMd &&
    mediaQuery(
      'md',
      css`
        max-width: ${cssVar($maxWidthMd)};
      `
    )}

  ${({ $maxWidthSm }) =>
    $maxWidthSm &&
    mediaQuery(
      'sm',
      css`
        max-width: ${cssVar($maxWidthSm)};
      `
    )}
`;
